import { Component, Children } from 'react';
export default class extends Component {
    shouldComponentUpdate(nextProps) {
        return nextProps.shouldUpdate;
    }
    render() {
        const child = this.props.children;
        return child === null || child === false ? null : Children.only(child);
    }
}
//# sourceMappingURL=StaticContainer.js.map